import React, { FC } from "react";
import { noop } from "lodash";
import type {
  TooltipDescriptiveProps,
  TooltipDescriptivePlacement
} from "./types";
import { Popper } from "../Popper";
import Content from "./content";

const CLOSE_DELAY: number = 30000;

export const TooltipDescriptive: FC<TooltipDescriptiveProps> = ({
  children,
  qaLabel,
  placement = "top-mid",
  isOpen = false,
  isDisabled = false,
  isDarkMode = false,
  closeDelay = CLOSE_DELAY,
  forceClose = false,
  onAction = "click",
  layer = 1999,
  isLeftSideRendered = false,
  showCaret = false,
  onClickOuside = noop,
  ...rest
}) => (
  <Popper
    on={onAction}
    placement={placement}
    isOpen={isOpen}
    isDisabled={isDisabled}
    layer={layer}
    forceClose={forceClose}
    closeDelay={closeDelay}
    isLeftSideRendered={isLeftSideRendered}
    showCaret={showCaret}
    onClickOuside={onClickOuside}
    content={
      <Content
        data-qa-label={qaLabel}
        placement={placement}
        isDarkMode={isDarkMode}
        {...rest}
      />
    }
  >
    {children}
  </Popper>
);

export type { TooltipDescriptiveProps, TooltipDescriptivePlacement };
export default TooltipDescriptive;
